import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common';

// PII-free fallback rendered by the top-level Sentry.ErrorBoundary when a render
// crash unmounts the page tree. It must NEVER surface the error message or component
// stack to the user — only a generic recovery prompt. The crash itself is reported to
// Sentry (with the React component stack) by the boundary.
type FullPageErrorProps = {
  onRetry?: () => void;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  text-align: center;
  padding: 24px;
  box-sizing: border-box;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

const ActionButton = styled.button<{ $primary?: boolean }>`
  cursor: pointer;
  border-radius: 8px;
  padding: 10px 20px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid ${({ theme }) => theme.colors.prussianBlue};
  color: ${({ theme, $primary }) => ($primary ? theme.colors.white : theme.colors.prussianBlue)};
  background: ${({ theme, $primary }) => ($primary ? theme.colors.prussianBlue : 'transparent')};
`;

const FullPageError: React.FC<FullPageErrorProps> = ({ onRetry }) => {
  const handleRetry = (): void => {
    if (onRetry) onRetry();
    else window.location.reload();
  };

  const handleHome = (): void => {
    window.location.href = '/';
  };

  return (
    <Container>
      <Poppins px={28} weight={600} color="prussianBlue">
        Something went wrong
      </Poppins>
      <ButtonRow>
        <ActionButton onClick={handleHome}>Back to home</ActionButton>
        <ActionButton $primary onClick={handleRetry}>
          Try again
        </ActionButton>
      </ButtonRow>
    </Container>
  );
};

export default FullPageError;
